import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DashBoardLayerOne from "../../components/DashBoardLayerOne";
import CategoriesTable from "../../components/CategoryManagement/CategoriesTable";
import CategoryTableV2 from "../../components/CategoryManagement/CategoryTableV2";


const CategoryManagement = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Categories" />

                {/* <CategoriesTable /> */}
                {/* <CategoriesTable/> */}

                <CategoryTableV2/>
                {/* DashBoardLayerOne */}
                {/* <DashBoardLayerOne /> */}

            </MasterLayout>
        </>
    );
};

export default CategoryManagement;
